/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedConnectionsRouteImport } from './routes/_authed/connections'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as ConectarIndexRouteImport } from './routes/conectar/index'
import { Route as ConectarErrorRouteImport } from './routes/conectar/error'
import { Route as ConectarListoRouteImport } from './routes/conectar/listo'
import { Route as AuthedCustomersIndexRouteImport } from './routes/_authed/customers/index'
import { Route as AuthedSupportIndexRouteImport } from './routes/_authed/support/index'
import { Route as AuthedSupportConversationIdRouteImport } from './routes/_authed/support/$conversationId'
import { Route as AuthedCustomersCustomerIdIndexRouteImport } from './routes/_authed/customers/$customerId/index'
import { Route as AuthedCustomersCustomerIdVisitsVisitIdRouteImport } from './routes/_authed/customers/$customerId/visits.$visitId'
import { Route as AuthedCustomersCustomerIdVisitsVisitIdIndexRouteImport } from './routes/_authed/customers/$customerId/visits.$visitId.index'
import { Route as AuthedCustomersCustomerIdVisitsVisitIdDossierRouteImport } from './routes/_authed/customers/$customerId/visits.$visitId.dossier'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedConnectionsRoute = AuthedConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const ConectarIndexRoute = ConectarIndexRouteImport.update({
  id: '/conectar/',
  path: '/conectar/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConectarErrorRoute = ConectarErrorRouteImport.update({
  id: '/conectar/error',
  path: '/conectar/error',
  getParentRoute: () => rootRouteImport,
} as any)
const ConectarListoRoute = ConectarListoRouteImport.update({
  id: '/conectar/listo',
  path: '/conectar/listo',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedCustomersIndexRoute = AuthedCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportIndexRoute = AuthedSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSupportConversationIdRoute =
  AuthedSupportConversationIdRouteImport.update({
    id: '/support/$conversationId',
    path: '/support/$conversationId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCustomersCustomerIdIndexRoute =
  AuthedCustomersCustomerIdIndexRouteImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCustomersCustomerIdVisitsVisitIdRoute =
  AuthedCustomersCustomerIdVisitsVisitIdRouteImport.update({
    id: '/customers/$customerId/visits/$visitId',
    path: '/customers/$customerId/visits/$visitId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCustomersCustomerIdVisitsVisitIdIndexRoute =
  AuthedCustomersCustomerIdVisitsVisitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedCustomersCustomerIdVisitsVisitIdRoute,
  } as any)
const AuthedCustomersCustomerIdVisitsVisitIdDossierRoute =
  AuthedCustomersCustomerIdVisitsVisitIdDossierRouteImport.update({
    id: '/dossier',
    path: '/dossier',
    getParentRoute: () => AuthedCustomersCustomerIdVisitsVisitIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/connections': typeof AuthedConnectionsRoute
  '/profile': typeof AuthedProfileRoute
  '/settings': typeof AuthedSettingsRoute
  '/conectar/error': typeof ConectarErrorRoute
  '/conectar/listo': typeof ConectarListoRoute
  '/conectar/': typeof ConectarIndexRoute
  '/support/$conversationId': typeof AuthedSupportConversationIdRoute
  '/customers/': typeof AuthedCustomersIndexRoute
  '/support/': typeof AuthedSupportIndexRoute
  '/customers/$customerId/': typeof AuthedCustomersCustomerIdIndexRoute
  '/customers/$customerId/visits/$visitId': typeof AuthedCustomersCustomerIdVisitsVisitIdRouteWithChildren
  '/customers/$customerId/visits/$visitId/dossier': typeof AuthedCustomersCustomerIdVisitsVisitIdDossierRoute
  '/customers/$customerId/visits/$visitId/': typeof AuthedCustomersCustomerIdVisitsVisitIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/connections': typeof AuthedConnectionsRoute
  '/profile': typeof AuthedProfileRoute
  '/settings': typeof AuthedSettingsRoute
  '/conectar/error': typeof ConectarErrorRoute
  '/conectar/listo': typeof ConectarListoRoute
  '/': typeof AuthedIndexRoute
  '/conectar': typeof ConectarIndexRoute
  '/support/$conversationId': typeof AuthedSupportConversationIdRoute
  '/customers': typeof AuthedCustomersIndexRoute
  '/support': typeof AuthedSupportIndexRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdIndexRoute
  '/customers/$customerId/visits/$visitId/dossier': typeof AuthedCustomersCustomerIdVisitsVisitIdDossierRoute
  '/customers/$customerId/visits/$visitId': typeof AuthedCustomersCustomerIdVisitsVisitIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/connections': typeof AuthedConnectionsRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/conectar/error': typeof ConectarErrorRoute
  '/conectar/listo': typeof ConectarListoRoute
  '/_authed/': typeof AuthedIndexRoute
  '/conectar/': typeof ConectarIndexRoute
  '/_authed/support/$conversationId': typeof AuthedSupportConversationIdRoute
  '/_authed/customers/': typeof AuthedCustomersIndexRoute
  '/_authed/support/': typeof AuthedSupportIndexRoute
  '/_authed/customers/$customerId/': typeof AuthedCustomersCustomerIdIndexRoute
  '/_authed/customers/$customerId/visits/$visitId': typeof AuthedCustomersCustomerIdVisitsVisitIdRouteWithChildren
  '/_authed/customers/$customerId/visits/$visitId/dossier': typeof AuthedCustomersCustomerIdVisitsVisitIdDossierRoute
  '/_authed/customers/$customerId/visits/$visitId/': typeof AuthedCustomersCustomerIdVisitsVisitIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/connections'
    | '/profile'
    | '/settings'
    | '/conectar/error'
    | '/conectar/listo'
    | '/conectar/'
    | '/support/$conversationId'
    | '/customers/'
    | '/support/'
    | '/customers/$customerId/'
    | '/customers/$customerId/visits/$visitId'
    | '/customers/$customerId/visits/$visitId/dossier'
    | '/customers/$customerId/visits/$visitId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/connections'
    | '/profile'
    | '/settings'
    | '/conectar/error'
    | '/conectar/listo'
    | '/'
    | '/conectar'
    | '/support/$conversationId'
    | '/customers'
    | '/support'
    | '/customers/$customerId'
    | '/customers/$customerId/visits/$visitId/dossier'
    | '/customers/$customerId/visits/$visitId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/connections'
    | '/_authed/profile'
    | '/_authed/settings'
    | '/conectar/error'
    | '/conectar/listo'
    | '/_authed/'
    | '/conectar/'
    | '/_authed/support/$conversationId'
    | '/_authed/customers/'
    | '/_authed/support/'
    | '/_authed/customers/$customerId/'
    | '/_authed/customers/$customerId/visits/$visitId'
    | '/_authed/customers/$customerId/visits/$visitId/dossier'
    | '/_authed/customers/$customerId/visits/$visitId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  ConectarErrorRoute: typeof ConectarErrorRoute
  ConectarListoRoute: typeof ConectarListoRoute
  ConectarIndexRoute: typeof ConectarIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/connections': {
      id: '/_authed/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof AuthedConnectionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/conectar/': {
      id: '/conectar/'
      path: '/conectar'
      fullPath: '/conectar/'
      preLoaderRoute: typeof ConectarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conectar/error': {
      id: '/conectar/error'
      path: '/conectar/error'
      fullPath: '/conectar/error'
      preLoaderRoute: typeof ConectarErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conectar/listo': {
      id: '/conectar/listo'
      path: '/conectar/listo'
      fullPath: '/conectar/listo'
      preLoaderRoute: typeof ConectarListoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/customers/': {
      id: '/_authed/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthedCustomersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/': {
      id: '/_authed/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthedSupportIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/support/$conversationId': {
      id: '/_authed/support/$conversationId'
      path: '/support/$conversationId'
      fullPath: '/support/$conversationId'
      preLoaderRoute: typeof AuthedSupportConversationIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/$customerId/': {
      id: '/_authed/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AuthedCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/$customerId/visits/$visitId': {
      id: '/_authed/customers/$customerId/visits/$visitId'
      path: '/customers/$customerId/visits/$visitId'
      fullPath: '/customers/$customerId/visits/$visitId'
      preLoaderRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/$customerId/visits/$visitId/': {
      id: '/_authed/customers/$customerId/visits/$visitId/'
      path: '/'
      fullPath: '/customers/$customerId/visits/$visitId/'
      preLoaderRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdIndexRouteImport
      parentRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdRoute
    }
    '/_authed/customers/$customerId/visits/$visitId/dossier': {
      id: '/_authed/customers/$customerId/visits/$visitId/dossier'
      path: '/dossier'
      fullPath: '/customers/$customerId/visits/$visitId/dossier'
      preLoaderRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdDossierRouteImport
      parentRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdRoute
    }
  }
}

interface AuthedCustomersCustomerIdVisitsVisitIdRouteChildren {
  AuthedCustomersCustomerIdVisitsVisitIdDossierRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdDossierRoute
  AuthedCustomersCustomerIdVisitsVisitIdIndexRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdIndexRoute
}

const AuthedCustomersCustomerIdVisitsVisitIdRouteChildren: AuthedCustomersCustomerIdVisitsVisitIdRouteChildren =
  {
    AuthedCustomersCustomerIdVisitsVisitIdDossierRoute:
      AuthedCustomersCustomerIdVisitsVisitIdDossierRoute,
    AuthedCustomersCustomerIdVisitsVisitIdIndexRoute:
      AuthedCustomersCustomerIdVisitsVisitIdIndexRoute,
  }

const AuthedCustomersCustomerIdVisitsVisitIdRouteWithChildren =
  AuthedCustomersCustomerIdVisitsVisitIdRoute._addFileChildren(
    AuthedCustomersCustomerIdVisitsVisitIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedConnectionsRoute: typeof AuthedConnectionsRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedSupportConversationIdRoute: typeof AuthedSupportConversationIdRoute
  AuthedCustomersIndexRoute: typeof AuthedCustomersIndexRoute
  AuthedSupportIndexRoute: typeof AuthedSupportIndexRoute
  AuthedCustomersCustomerIdIndexRoute: typeof AuthedCustomersCustomerIdIndexRoute
  AuthedCustomersCustomerIdVisitsVisitIdRoute: typeof AuthedCustomersCustomerIdVisitsVisitIdRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedConnectionsRoute: AuthedConnectionsRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedSupportConversationIdRoute: AuthedSupportConversationIdRoute,
  AuthedCustomersIndexRoute: AuthedCustomersIndexRoute,
  AuthedSupportIndexRoute: AuthedSupportIndexRoute,
  AuthedCustomersCustomerIdIndexRoute: AuthedCustomersCustomerIdIndexRoute,
  AuthedCustomersCustomerIdVisitsVisitIdRoute:
    AuthedCustomersCustomerIdVisitsVisitIdRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  ConectarErrorRoute: ConectarErrorRoute,
  ConectarListoRoute: ConectarListoRoute,
  ConectarIndexRoute: ConectarIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
